import { Route } from '@angular/router';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { InitialDataResolver } from 'app/app.resolvers';

export const appRoutes: Route[] = [

    // ============================================
    // RUTAS PÚBLICAS PRINCIPALES (SEO-FRIENDLY)
    // ============================================
    {
        path: '',
        component: LayoutComponent,
        data: { layout: 'modern' },
        children: [
            // Página principal en la raíz (budget-default)
            { 
                path: '', 
                loadChildren: () => import('app/modules/public/master-page/budget-default/budget-default.module')
                    .then(m => m.BudgetDefaultModule) 
            },
            
            // Prototipo (budget-home)
            { 
                path: 'beta', 
                loadChildren: () => import('app/modules/public/master-page/budget-home/budget-home.module')
                    .then(m => m.BudgetHomeModule) 
            },
             { 
                path: 'products', 
                loadChildren: () => import('app/modules/public/master-page/budget-default/budget-default.module')
                    .then(m => m.BudgetDefaultModule) 
            },
            // Detalles de productos (usando urlcard en lugar de uid)
            { 
                path: 'products/:urlcard', 
                loadChildren: () => import('app/modules/public/master-page/budget-details/budget-details.module')
                    .then(m => m.BudgetDetailsModule) 
            },
            
            // Páginas de información
            { 
                path: 'contact', 
                loadChildren: () => import('app/modules/public/master-page/customer-contact/customer-contact.module')
                    .then(m => m.CustomerContactModule) 
            },
            { 
                path: 'pricing', 
                loadChildren: () => import('app/modules/public/master-page/pricing/pricing.module')
                    .then(m => m.PricingModule) 
            },
            
            // Blog (usando urlarticle en lugar de uid)
            { 
                path: 'blog', 
                loadChildren: () => import('app/modules/public/master-page/blog/blog.module')
                    .then(m => m.BlogModule) 
            },
            { 
                path: 'blog/:urlarticle', 
                loadChildren: () => import('app/modules/public/master-page/blog/blog-details/blog-details.module')
                    .then(m => m.BlogDetailsModule) 
            },
            { 
                path: 'blog2', 
                loadChildren: () => import('app/modules/public/master-page/blog2/blog2.module')
                    .then(m => m.Blog2Module) 
            },
            
            // Servicios de reservación
            { 
                path: 'akumal', 
                loadChildren: () => import('app/modules/public/master-page/budget-akumal/budget-akumal.module')
                    .then(m => m.BudgetAkumalModule) 
            },
            { 
                path: 'agencies', 
                loadChildren: () => import('app/modules/public/master-page/budget-agencies/budget-agencies.module')
                    .then(m => m.BudgetAgenciesModule) 
            },
            { 
                path: 'agencies/:codeuser', 
                loadChildren: () => import('app/modules/public/master-page/budget-agencies/budget-agencies.module')
                    .then(m => m.BudgetAgenciesModule) 
            },
            { 
                path: 'reserve', 
                loadChildren: () => import('app/modules/public/master-page/budget-reserve/budget-reserve.module')
                    .then(m => m.BudgetReserveModule) 
            },
            { 
                path: 'reserve/:codereserve', 
                loadChildren: () => import('app/modules/public/master-page/budget-reserve/budget-reserve.module')
                    .then(m => m.BudgetReserveModule) 
            },
            { 
                path: 'privatereserve', 
                loadChildren: () => import('app/modules/public/master-page/budget-privatereserve/budget-privatereserve.module')
                    .then(m => m.BudgetPrivatereserveModule) 
            },
            { 
                path: 'privatereserve/:codereserve', 
                loadChildren: () => import('app/modules/public/master-page/budget-privatereserve/budget-privatereserve.module')
                    .then(m => m.BudgetPrivatereserveModule) 
            },
            { 
                path: 'quote', 
                loadChildren: () => import('app/modules/public/master-page/budget-quote/budget-quote.module')
                    .then(m => m.BudgetQuoteModule) 
            },
            { 
                path: 'quote/price/:codereserve', 
                loadChildren: () => import('app/modules/public/master-page/budget-quote/budget-quote.module')
                    .then(m => m.BudgetQuoteModule) 
            },
            { 
                path: 'privatequote', 
                loadChildren: () => import('app/modules/public/master-page/budget-privatequote/budget-privatequote.module')
                    .then(m => m.BudgetPrivatequoteModule) 
            },
            { 
                path: 'privatequote/price/:codereserve', 
                loadChildren: () => import('app/modules/public/master-page/budget-privatequote/budget-privatequote.module')
                    .then(m => m.BudgetPrivatequoteModule) 
            },
        ]
    },

    // ============================================
    // AUTENTICACIÓN
    // ============================================
    {
        path: '',
        component: LayoutComponent,
        data: { layout: 'empty' },
        children: [
            { 
                path: 'sign-in', 
                loadChildren: () => import('app/modules/public/authentication/sign-in/sign-in.module')
                    .then(m => m.SignInModule) 
            },
            { 
                path: 'sign-up', 
                loadChildren: () => import('app/modules/auth/sign-up/sign-up.module')
                    .then(m => m.AuthSignUpModule) 
            },
            { 
                path: 'forgot-password', 
                loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.module')
                    .then(m => m.AuthForgotPasswordModule) 
            },
            { 
                path: 'reset-password', 
                loadChildren: () => import('app/modules/auth/reset-password/reset-password.module')
                    .then(m => m.AuthResetPasswordModule) 
            },
            { 
                path: 'confirmation-required', 
                loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.module')
                    .then(m => m.AuthConfirmationRequiredModule) 
            },
            { 
                path: 'confirmation-email', 
                loadChildren: () => import('app/modules/auth/confirmation-email/confirmation-email.module')
                    .then(m => m.ConfirmationEmailModule) 
            },
            { 
                path: 'company', 
                loadChildren: () => import('app/modules/public/authentication/create-enterprise/create-enterprise.module')
                    .then(m => m.CreateEnterpriseModule) 
            },
            { 
                path: 'delete-inactive-old-users', 
                loadChildren: () => import('app/modules/public/authentication/delete-inactive-old-users/delete-inactive-old-users.module')
                    .then(m => m.DeleteInactiveOldUsersModule) 
            },
            { 
                path: 'generate-sitemap', 
                loadChildren: () => import('app/modules/public/authentication/generate-sitemap/generate-sitemap.module')
                    .then(m => m.GenerateSitemapModule) 
            },
        ]
    },

    // ============================================
    // RUTAS PRIVADAS (requieren autenticación)
    // ============================================
    {
        path: 'p',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: { layout: 'classic' },
        resolve: { initialData: InitialDataResolver },
        children: [
            { 
                path: '', 
                pathMatch: 'full', 
                redirectTo: 'main' 
            },
            { 
                path: 'main', 
                loadChildren: () => import('app/modules/private/main/main.module')
                    .then(m => m.MainModule) 
            },
            {
                path: 'services',
                children: [
                    { path: '', pathMatch: 'full', redirectTo: 'main' },
                    { 
                        path: 'bookings', 
                        loadChildren: () => import('app/modules/private/services/services-bookings/services-bookings.module')
                            .then(m => m.ServicesBookingsModule) 
                    },
                    { 
                        path: 'main', 
                        loadChildren: () => import('app/modules/private/services/services-main/services-main.module')
                            .then(m => m.ServicesMainModule) 
                    },
                ]
            },
            {
                path: 'tools',
                children: [
                    { path: '', pathMatch: 'full', redirectTo: 'calendar' },
                    { 
                        path: 'calendar', 
                        loadChildren: () => import('app/modules/private/tools/tools-calendar/tools-calendar.module')
                            .then(m => m.ToolsCalendarModule) 
                    },
                ]
            },
            {
                path: 'setup',
                children: [
                    { path: '', pathMatch: 'full', redirectTo: 'companies' },
                    { 
                        path: 'companies', 
                        loadChildren: () => import('app/modules/private/setup/setup-companies/setup-companies.module')
                            .then(m => m.SetupCompaniesModule) 
                    },
                    { 
                        path: 'modules', 
                        loadChildren: () => import('app/modules/private/setup/setup-modules/setup-modules.module')
                            .then(m => m.SetupModulesModule) 
                    },
                    { 
                        path: 'currencies', 
                        loadChildren: () => import('app/modules/private/setup/setup-currencies/setup-currencies.module')
                            .then(m => m.SetupCurrenciesModule) 
                    },
                    { 
                        path: 'airports', 
                        loadChildren: () => import('app/modules/private/setup/setup-airports/setup-airports.module')
                            .then(m => m.SetupAirportsModule) 
                    },
                    { 
                        path: 'airlines', 
                        loadChildren: () => import('app/modules/private/setup/setup-airlines/setup-airlines.module')
                            .then(m => m.SetupAirlinesModule) 
                    },
                    { 
                        path: 'transfers', 
                        loadChildren: () => import('app/modules/private/setup/setup-transfers/setup-transfers.module')
                            .then(m => m.SetupTransfersModule) 
                    },
                    { 
                        path: 'private', 
                        loadChildren: () => import('app/modules/private/setup/setup-private/setup-private.module')
                            .then(m => m.SetupPrivateModule) 
                    },
                    { 
                        path: 'codes', 
                        loadChildren: () => import('app/modules/private/setup/setup-codes/setup-codes.module')
                            .then(m => m.SetupCodesModule) 
                    },
                ]
            },
            {
                path: 'view',
                children: [
                    { path: '', pathMatch: 'full', redirectTo: 'logos' },
                    { 
                        path: 'logos', 
                        loadChildren: () => import('app/modules/private/view/view-logos/view-logos.module')
                            .then(m => m.ViewLogosModule) 
                    },
                    { 
                        path: 'images', 
                        loadChildren: () => import('app/modules/private/view/view-images/view-images.module')
                            .then(m => m.ViewImagesModule) 
                    },
                ]
            },
            { 
                path: 'sign-out', 
                loadChildren: () => import('app/modules/auth/sign-out/sign-out.module')
                    .then(m => m.AuthSignOutModule) 
            },
        ]
    },

    // ============================================
    // WILDCARD - Ruta no encontrada
    // ============================================
    { path: '**', redirectTo: '' }
];